import styled from '@emotion/styled';
export const BigDropZone = styled.div`
  width: 600px;
  height: 100px;
  background-color: ${(props: any) => (props.isDragActive ? '#ffffffcc' : '')};
  opacity: ${(props: any) => (props.isDragActive ? '1' : '0')};
  z-index: 99;
  position: absolute;
  top: 110;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
